// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'nprogress/nprogress.css'
import 'video.js/dist/video-js.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './locales'
import './components/global.less'
import './assets/markdown.less'

import './core/use'
import './icons'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

// 提示组件
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  methods: {
    languageCodes (config, formatMode = 'toString') {
      const codes = {
        'zh_CN': 'Cn'[formatMode](),
        'zh_TW': 'Tw'[formatMode](),
        'ko_KR': 'Kr'[formatMode](),
        'en_US': 'En'[formatMode](),
        'pt_BR': 'Pb'[formatMode]()
      }
      return { ...codes, ...config }
    }
  },
  render: h => h(App)
}).$mount('#app')
